/**
 * True when a player has a non-healthy game status (mirrors roster injury report logic).
 */
export default function isInjuredStatus(status) {
	if (!status) return false;

	const normalized = status.toLowerCase();

	if (normalized === 'active' || normalized.includes('healthy')) {
		return false;
	}

	return true;
}
